<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-card flat class="mx-auto public-form transparent">
          <v-card outlined id="confirm-registration">
            <v-card-text class="text-center">
              <v-img :src="$app.opts.authLogoSrc" :alt="$app.opts.title" max-height="250" contain />
            </v-card-text>

            <div v-if="!confirmed">
              <v-card-text class="text-center title">
                <h3>{{ $t('verify') }}</h3>
              </v-card-text>
              <v-card-text class="text-center">
                <FormErrors :show="showResourceErrors" :errors="resourceErrors" />
                {{ $t('verifyMessage') }}
              </v-card-text>
            </div>

            <div v-if="confirmed">
              <v-card-text class="text-center title">
                <h3>{{ $t('registrationConfirmed') }}</h3>
              </v-card-text>
              <v-card-text class="text-center">{{ $t('registrationConfirmedMessage') }}</v-card-text>
            </div>

            <v-card-text class="py-2 text-center">
              <v-btn block depressed color="accent" @click="goToProfile">{{ $t('goToProfile') }}</v-btn>
            </v-card-text>
          </v-card>

          <v-card flat class="my-3 transparent text-center">
            <LanguageField use-buttons v-model="myLlocale" immediate fieldClass="elevation-0" />
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <RefreshApp />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { BaseForm, FormErrors, LanguageField, RefreshApp } from '@argon/app/components'
import { NAMESPACE } from '../store'
import { NAMESPACE as ME_NAMESPACE } from '@argon/iam/me/store'

export default {
  extends: BaseForm,
  components: { FormErrors, LanguageField, RefreshApp },
  validations: {
    form: {}
  },
  data: () => ({
    form: {},
    confirmed: false
  }),
  props: {
    token: {
      type: String,
      default: 'invalidToken'
    }
  },
  computed: {
    ...mapGetters(ME_NAMESPACE, ['locale']),
    myLocale: {
      get() {
        return this.locale
      },
      set(v) {
        this.setLocale(v)
      }
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['verify']),
    ...mapActions(ME_NAMESPACE, ['setLocale']),
    confirm() {
      const payload = {
        token: this.token
      }
      this.verify(payload)
        .then(() => {
          this.confirmed = true
        })
        .catch(this.setServerErrors)
    },
    goToProfile() {
      this.$router.push({ name: 'me', params: { reload: true } })
    }
  },
  mounted() {
    this.confirm()
  }
}
</script>

<i18n>
{
  "en": {
    "goToProfile": "Go to Profile",
    "registrationConfirmed": "Confirmed !",
    "registrationConfirmedMessage": "Congratulations! Your account is now confirmed.",
    "signin": "@:labels.signin",
    "verify": "Confirming Registration",
    "verifyMessage": "Please wait while we complete the confirmation process."
  },
  "fr": {
    "goToProfile": "Aller au profil",
    "registrationConfirmed": "Confirmé !",
    "registrationConfirmedMessage": "Félicitations! Votre compte est maintenant confirmé.",
    "signin": "@:labels.signin",
    "verify": "Confirmation d'inscription",
    "verifyMessage": "Veuillez patienter pendant que nous finalisons l'inscription."
  }
}
</i18n>
